var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "am-g am-margin-bottom-sm" },
    [
      _c(
        "Card",
        { attrs: { headerStyle: { background: "#d4d5d5" }, "dis-hover": "" } },
        [
          _c("h2", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("更多信息 ")
          ]),
          _vm.store.storeId
            ? _c("div", { staticClass: "form" }, [
                _c(
                  "div",
                  { staticClass: "form-item" },
                  [
                    _c("div", { staticClass: "form-item-label" }, [
                      _vm._v("支付方式：")
                    ]),
                    !_vm.isAmend
                      ? void 0
                      : [
                          _c(
                            "div",
                            { staticClass: "form-item-content" },
                            [
                              _c(
                                "Button",
                                {
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.showOrderAmendPayModal.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v("修改支付方式")]
                              )
                            ],
                            1
                          )
                        ]
                  ],
                  2
                ),
                _vm.store.invoiceType.length > 0 || _vm.isAmend
                  ? _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-item-label" }, [
                        _vm._v("发票：")
                      ]),
                      _c(
                        "div",
                        { staticClass: "form-item-content" },
                        [
                          _vm.isAmend
                            ? _c("div", { staticClass: "order-amend-hint" }, [
                                _vm.oldOrderData.isInvoice &&
                                _vm.oldOrderData.invoiceType !== 0
                                  ? _c("span", [
                                      _c("span", [_vm._v("需要")]),
                                      _vm.oldOrderData.invoiceType === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "am-padding-left-xs"
                                            },
                                            [_vm._v("定额发票")]
                                          )
                                        : _c("span", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "am-padding-left-xs"
                                              },
                                              [_vm._v("机打发票")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "am-padding-left-xs"
                                              },
                                              [
                                                _vm._v(
                                                  "发票抬头" +
                                                    _vm._s(
                                                      _vm.oldOrderData
                                                        .invoiceDesc
                                                    )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "am-padding-left-xs"
                                              },
                                              [
                                                _vm._v(
                                                  "税号" +
                                                    _vm._s(
                                                      _vm.oldOrderData.taxNo
                                                    )
                                                )
                                              ]
                                            )
                                          ])
                                    ])
                                  : _c("span", [
                                      _c("span", [
                                        _vm._v("不需要发票/"),
                                        _c(
                                          "span",
                                          { staticClass: "am-padding-left-xs" },
                                          [_vm._v("定额发票 机打发票")]
                                        )
                                      ])
                                    ])
                              ])
                            : _vm._e(),
                          _c(
                            "RadioGroup",
                            {
                              model: {
                                value: _vm.invoiceType,
                                callback: function($$v) {
                                  _vm.invoiceType = $$v
                                },
                                expression: "invoiceType"
                              }
                            },
                            [
                              _c("Radio", { attrs: { label: 0 } }, [
                                _vm._v("不需要")
                              ]),
                              _vm._l(_vm.store.invoiceType, function(
                                item,
                                index
                              ) {
                                return _c("Radio", {
                                  key: index,
                                  staticStyle: { display: "block" },
                                  attrs: { label: item },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var currentValue = ref.currentValue
                                          return [
                                            item === 1
                                              ? [
                                                  _c("span", [
                                                    _vm._v("定额发票")
                                                  ])
                                                ]
                                              : item === 2
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-item-content",
                                                      staticStyle: {
                                                        display: "inline-block"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "form-item-content"
                                                        },
                                                        [_vm._v("机打发票")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-item-content am-padding-left-sm"
                                                        },
                                                        [
                                                          _c("Input", {
                                                            attrs: {
                                                              placeholder:
                                                                "发票抬头",
                                                              disabled: !currentValue
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.invoiceDesc,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.invoiceDesc = $$v
                                                              },
                                                              expression:
                                                                "invoiceDesc"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "form-item-content am-padding-left-sm"
                                                        },
                                                        [
                                                          _c("Input", {
                                                            attrs: {
                                                              placeholder:
                                                                "税号",
                                                              disabled: !currentValue
                                                            },
                                                            model: {
                                                              value: _vm.taxNo,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.taxNo = $$v
                                                              },
                                                              expression:
                                                                "taxNo"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c("span", {
                                                        staticClass:
                                                          "form-item-content"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                  电子发票\n                "
                                                  )
                                                ]
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm.isAmend
                  ? _c("div", { staticClass: "form-item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-item-label prefix-price-unit desc"
                        },
                        [_vm._v("原订单发票：")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-item-content desc am-margin-left-10"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.preferential.orderData.invoiceTypeName || ""
                            )
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                !_vm.isAmend
                  ? _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-item-label" }, [
                        _vm._v("用户喜好：")
                      ]),
                      _c(
                        "div",
                        { staticClass: "form-item-content" },
                        [
                          _c("Input", {
                            attrs: { clearable: "" },
                            on: {
                              "on-blur": function($event) {
                                return _vm.updateTaste(_vm.taste)
                              }
                            },
                            model: {
                              value: _vm.taste,
                              callback: function($$v) {
                                _vm.taste = $$v
                              },
                              expression: "taste"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-item-content am-padding-left-sm" },
                        [
                          _c(
                            "Button",
                            {
                              nativeOn: {
                                click: function($event) {
                                  _vm.userNote = _vm.taste + ";"
                                }
                              }
                            },
                            [_vm._v("添加到订单备注")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "form-item" }, [
                  _c("div", { staticClass: "form-item-label" }, [
                    _vm._v("订单备注：")
                  ]),
                  _c("div", { staticClass: "form-item-content" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userNote,
                          expression: "userNote"
                        }
                      ],
                      staticClass: "am-input",
                      attrs: { rows: "6", cols: "30" },
                      domProps: { value: _vm.userNote },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.userNote = $event.target.value
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "form-item-label" }, [
                    _c(
                      "a",
                      {
                        staticClass: "am-margin-left-sm",
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            _vm.userNote += "餐具份数："
                          }
                        }
                      },
                      [_c("span", [_vm._v("餐具份数")])]
                    )
                  ])
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.orderPayChildOptions.length && !_vm.isAmend,
                        expression: "orderPayChildOptions.length&&!isAmend"
                      }
                    ],
                    staticClass: "form-item"
                  },
                  [
                    _c("div", { staticClass: "form-item-label" }, [
                      _vm._v("下单方式：")
                    ]),
                    _c(
                      "div",
                      { staticClass: "form-item-content" },
                      [
                        _c("cc-select", {
                          attrs: {
                            options: _vm.orderPayChildOptions,
                            placeholder: "请选择下单方式",
                            width: 130
                          },
                          model: {
                            value: _vm.orderPayChild,
                            callback: function($$v) {
                              _vm.orderPayChild = $$v
                            },
                            expression: "orderPayChild"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.actualOrderChannel && !_vm.isAmend,
                        expression: "actualOrderChannel&&!isAmend"
                      }
                    ],
                    staticClass: "form-item"
                  },
                  [
                    _c("div", { staticClass: "form-item-label" }, [
                      _vm._v("实际下单渠道")
                    ]),
                    _c(
                      "div",
                      { staticClass: "form-item-content" },
                      [
                        _c("cc-select", {
                          attrs: {
                            options: _vm.channelList,
                            labelKey: "name",
                            valueKey: "id",
                            placeholder: "请选择",
                            width: 130
                          },
                          model: {
                            value: _vm.actualOrderChannelType,
                            callback: function($$v) {
                              _vm.actualOrderChannelType = $$v
                            },
                            expression: "actualOrderChannelType"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c("div", { staticClass: "form-item" }, [
                  _c("div", { staticClass: "form-item-label" }, [
                    _vm._v("商家备注：")
                  ]),
                  _c("div", { staticClass: "form-item-content" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.storeNoteContent,
                          expression: "storeNoteContent"
                        }
                      ],
                      staticClass: "am-input",
                      attrs: { rows: "6", cols: "30" },
                      domProps: { value: _vm.storeNoteContent },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.storeNoteContent = $event.target.value
                        }
                      }
                    }),
                    _c("p", { staticClass: "tip" }, [
                      _vm._v(
                        _vm._s(_vm._f("lang")("*订单备注：客户的订单备注/要求"))
                      )
                    ]),
                    _c("p", { staticClass: "tip" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("lang")(
                            "商家备注：门店内部使用的订单备注/标记"
                          )
                        )
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _c(
        "div",
        {
          staticClass: "am-text-center am-padding-vertical-sm",
          staticStyle: { "background-color": "#ebedef" }
        },
        [
          _c(
            "Button",
            {
              attrs: { type: "info", size: "large" },
              nativeOn: {
                click: function($event) {
                  return _vm.checkOrder.apply(null, arguments)
                }
              }
            },
            [_vm._v("核对订单")]
          )
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { width: "850px" },
          model: {
            value: _vm.orderVisible,
            callback: function($$v) {
              _vm.orderVisible = $$v
            },
            expression: "orderVisible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("核对订单")
          ]),
          _vm.orderVisible
            ? _c("div", { staticClass: "order" }, [
                _c("div", { staticClass: "order-pane" }, [
                  _c("div", { staticClass: "order-pane-title" }, [
                    _vm._v("\n          餐品\n        ")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "am-g am-g-collapse am-padding-horizontal-sm",
                      staticStyle: {
                        "max-height": "200px",
                        "overflow-y": "auto"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "am-u-sm-12 order-cart-title am-margin-vertical-xs"
                        },
                        [
                          _c("div", { staticClass: "am-u-sm-1" }, [
                            _vm._v("份数")
                          ]),
                          _c("div", { staticClass: "am-u-sm-5" }, [
                            _vm._v("餐品")
                          ]),
                          _c("div", { staticClass: "am-u-sm-3" }, [
                            _vm._v("总价")
                          ]),
                          _c("div", { staticClass: "am-u-sm-3" }, [
                            _vm._v("餐品备注")
                          ])
                        ]
                      ),
                      _vm._l(
                        _vm.products.concat(_vm.cart.outMenuProducts),
                        function(item, key) {
                          return _c(
                            "div",
                            {
                              key: key,
                              staticClass:
                                "am-u-sm-12 order-cart-item am-margin-vertical-xs"
                            },
                            [
                              _c("div", { staticClass: "am-u-sm-1" }, [
                                _vm._v(_vm._s(item.num) + "份")
                              ]),
                              _c("div", { staticClass: "am-u-sm-5" }, [
                                _vm._v(_vm._s(item.name))
                              ]),
                              _c("div", { staticClass: "am-u-sm-3" }, [
                                _vm._v(
                                  _vm._s(_vm.currency) +
                                    _vm._s(item.totalProductPrice)
                                )
                              ]),
                              _c("div", { staticClass: "am-u-sm-3" }, [
                                _vm._v(_vm._s(item._remark))
                              ]),
                              item.isRequirement
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-u-sm-11 am-u-sm-offset-1"
                                      },
                                      [
                                        _c("span", { staticClass: "am-fl" }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item.desc.join("/")) +
                                              "\n                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                : item.type === 2
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-u-sm-12 am-margin-vertical-sm"
                                      },
                                      _vm._l(item.products, function(
                                        product,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "am-u-sm-12"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "am-u-sm-1" },
                                              [_vm._v(_vm._s(product.num))]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "am-u-sm-11" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "-" +
                                                      _vm._s(product.name) +
                                                      " "
                                                  )
                                                ])
                                              ]
                                            ),
                                            product.desc
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "am-u-sm-12 am-padding-top-sm"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "am-u-sm-11 am-u-sm-offset-1"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              product.desc.join(
                                                                "/"
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        }
                      )
                    ],
                    2
                  )
                ]),
                _c("div", { staticClass: "order-pane" }, [
                  _c("div", { staticClass: "order-pane-title" }, [
                    _vm._v("\n          其他费用\n        ")
                  ]),
                  _c("div", { staticClass: "am-g am-padding-horizontal-sm" }, [
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isDelivery ||
                              _vm.orderType === 1 ||
                              _vm.orderType === 4,
                            expression:
                              "isDelivery|| orderType=== 1 || orderType === 4"
                          }
                        ],
                        staticClass: "am-margin-vertical-xs"
                      },
                      [
                        _c("span", [_vm._v("配送费：")]),
                        _c("span", { staticClass: "prefix-price-unit" }, [
                          _vm._v(
                            _vm._s(_vm.currency) +
                              _vm._s(
                                _vm._f("formatPrice")(_vm.deliveryFee, true)
                              )
                          )
                        ])
                      ]
                    ),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.fee.mealFee,
                            expression: "fee.mealFee"
                          }
                        ],
                        staticClass: "am-margin-vertical-xs"
                      },
                      [
                        _c("span", [_vm._v("餐盒费：")]),
                        _c("span", { staticClass: "prefix-price-unit" }, [
                          _vm._v(
                            _vm._s(_vm.currency) +
                              _vm._s(
                                _vm._f("formatPrice")(_vm.fee.mealFee, true)
                              )
                          )
                        ])
                      ]
                    ),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.raisePriceTotal,
                            expression: "raisePriceTotal"
                          }
                        ],
                        staticClass: "am-margin-vertical-xs"
                      },
                      [
                        _c("span", [
                          _vm._v("\n              满加：\n            ")
                        ]),
                        _c("span", { staticClass: "prefix-price-unit" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.currency) +
                              _vm._s(
                                _vm._f("formatPrice")(_vm.raisePriceTotal, true)
                              ) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.subtractAmount,
                            expression: "subtractAmount"
                          }
                        ],
                        staticClass: "am-margin-vertical-xs"
                      },
                      [
                        _c("span", [
                          _vm._v("\n              优惠总金额：\n            ")
                        ]),
                        _c("span", { staticClass: "prefix-price-unit" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.currency) +
                              _vm._s(
                                _vm._f("formatPrice")(_vm.subtractAmount, true)
                              ) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cardMsg,
                            expression: "cardMsg"
                          }
                        ],
                        staticClass: "am-margin-vertical-xs"
                      },
                      [
                        _c("span", [
                          _vm._v("\n              优惠卡：\n            ")
                        ]),
                        _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.cardMsg) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass:
                          "am-margin-vertical-xs order-total order-text-orange"
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n              顾客" +
                              _vm._s(_vm.diffFee > 0 ? "需付" : "需退") +
                              "：\n            "
                          )
                        ]),
                        _vm.isAmend
                          ? [
                              _vm.diffFee > 0
                                ? [
                                    _vm._v(
                                      " (" +
                                        _vm._s(
                                          _vm._f("offlinePaysStr")(
                                            _vm.orderOfflinePayTypeOptions
                                          )
                                        ) +
                                        ")"
                                    )
                                  ]
                                : _vm.diffFee < 0
                                ? [
                                    _vm._v(
                                      " (" +
                                        _vm._s(
                                          _vm.getRefundDesc(_vm.refund.value)
                                        ) +
                                        _vm._s(_vm.refund.money) +
                                        ")"
                                    )
                                  ]
                                : [_vm._v("(0)")]
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]),
                _c("div", { staticClass: "order-pane" }, [
                  _c("div", { staticClass: "order-pane-title" }, [
                    _vm._v("\n          收货地址\n        ")
                  ]),
                  _c("div", { staticClass: "am-g am-padding-horizontal-sm" }, [
                    _c("p", { staticClass: "am-margin-vertical-xs" }, [
                      _c("span", [_vm._v("收货人：")]),
                      _c("span", [_vm._v(_vm._s(_vm.name))])
                    ]),
                    _c("p", { staticClass: "am-margin-vertical-xs" }, [
                      _c("span", [_vm._v("收货人电话：")]),
                      _vm.countryCode
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-right": "10px",
                                "border-right": "1px solid #ccc",
                                "padding-right": "10px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.countryCode))]
                          )
                        : _vm._e(),
                      _c("span", [_vm._v(_vm._s(_vm.phone))])
                    ]),
                    _c(
                      "p",
                      { staticClass: "am-margin-vertical-xs" },
                      [
                        _vm.sendType === 2
                          ? [
                              _c("span", [_vm._v("门店地址：")]),
                              _c("span", [
                                _vm._v(
                                  "\n                   " +
                                    _vm._s(_vm.store.storeAddress) +
                                    "\n                "
                                )
                              ])
                            ]
                          : [
                              _c("span", [_vm._v("收货地址：")]),
                              _c("span", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.address) +
                                    "\n                "
                                )
                              ])
                            ]
                      ],
                      2
                    ),
                    !_vm.isAmend
                      ? _c(
                          "p",
                          { staticClass: "am-margin-vertical-xs" },
                          [
                            _vm.orderType === 1
                              ? [
                                  _c("span", [_vm._v("订单预计：")]),
                                  _c("span", [
                                    _vm._v("在"),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "order-delivery order-text-orange"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.store.waitTime) + "分钟"
                                        )
                                      ]
                                    ),
                                    _vm._v("到达")
                                  ])
                                ]
                              : _vm.orderType === 4
                              ? [
                                  _c("span", [_vm._v("外卖预约：")]),
                                  _c("span", [
                                    _vm._v("订单预计在"),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "order-delivery order-text-orange"
                                      },
                                      [_vm._v(_vm._s(_vm.selfGetTime))]
                                    ),
                                    _vm._v("左右送达")
                                  ])
                                ]
                              : [
                                  _c("span", [
                                    _vm._v(
                                      "\n                自取：\n              "
                                    )
                                  ]),
                                  _c("span", [
                                    _vm._v("\n                请在"),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "order-delivery order-text-orange"
                                      },
                                      [_vm._v(_vm._s(_vm.selfGetTime))]
                                    ),
                                    _vm._v("左右到门店取餐\n              ")
                                  ])
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "am-text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  attrs: { loading: _vm.submitLoading },
                  nativeOn: {
                    click: function($event) {
                      return _vm.saveOrder.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("提交订单")]
              ),
              _c(
                "Button",
                {
                  staticClass: "am-btn-cancel",
                  nativeOn: {
                    click: function($event) {
                      _vm.orderVisible = false
                    }
                  }
                },
                [_vm._v("返回修改")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "Modal",
        {
          attrs: { width: "850px" },
          model: {
            value: _vm.orderAmendPayModal.visible,
            callback: function($$v) {
              _vm.$set(_vm.orderAmendPayModal, "visible", $$v)
            },
            expression: "orderAmendPayModal.visible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("修改支付方式")
          ]),
          _c("div", { staticClass: "order-amend-pay" }, [
            _c("div", { staticClass: "order-amend-hint" }, [
              _vm._v("说明：请根据客户需求，调整具体个线下支付类型金额"),
              _c("span", [
                _vm._v(
                  "( " +
                    _vm._s(_vm.diffFee > 0 ? "需补" : "需退") +
                    _vm._s(_vm.currency) +
                    _vm._s(Math.abs(_vm.diffFee)) +
                    " )"
                )
              ])
            ]),
            _c("div", { staticClass: "form am-margin-top-xs" }, [
              _c("div", { staticClass: "form-item am-margin-bottom-0" }, [
                _c("div", { staticClass: "form-item-label" }, [
                  _vm._v("订单应收：")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "form-item-content prefix-price-unit am-color-price"
                  },
                  [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.fee.total))]
                )
              ]),
              _c("div", { staticClass: "form-item am-margin-bottom-0" }, [
                _c("div", { staticClass: "form-item-label" }, [
                  _vm._v("订单已付：")
                ]),
                _c(
                  "div",
                  { staticClass: "form-item-content prefix-price-unit" },
                  [
                    _c(
                      "ul",
                      _vm._l(_vm.originOrderData.paymentDetails || [], function(
                        item,
                        idx
                      ) {
                        return _c("li", { key: idx }, [
                          _c("span", { staticClass: "pay-name" }, [
                            _vm._v(_vm._s(item.typeName))
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.payDifferenceType == 2
                                  ? "-"
                                  : item.payDifferenceType == 1
                                  ? "+"
                                  : ""
                              ) + _vm._s(item.money)
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ]
                )
              ]),
              _vm.diffFee < 0
                ? _c("div", { staticClass: "form-item am-margin-bottom-0" }, [
                    _c("div", { staticClass: "form-item-label" }, [
                      _vm._v("商家退款：")
                    ]),
                    _c(
                      "div",
                      { staticClass: "form-item-content" },
                      [
                        _c("cc-select", {
                          staticClass: "select",
                          attrs: {
                            width: 160,
                            options: _vm.orderRefundOptions
                          },
                          model: {
                            value: _vm.refund.value,
                            callback: function($$v) {
                              _vm.$set(_vm.refund, "value", $$v)
                            },
                            expression: "refund.value"
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "am-inline-block am-text-not-line am-margin-left-10"
                          },
                          [
                            _c("Input", {
                              model: {
                                value: _vm.refund.money,
                                callback: function($$v) {
                                  _vm.$set(_vm.refund, "money", $$v)
                                },
                                expression: "refund.money"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.diffFee > 0
                ? _c("div", { staticClass: "form-item am-margin-bottom-0" }, [
                    _c("div", { staticClass: "form-item-label" }, [
                      _vm._v("商家收款：")
                    ]),
                    _c(
                      "div",
                      { staticClass: "form-item-content" },
                      [
                        _c(
                          "CheckboxGroup",
                          {
                            staticClass: "am-flex am-flex-column",
                            model: {
                              value: _vm.orderAmendPayModal.payCheck,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.orderAmendPayModal,
                                  "payCheck",
                                  $$v
                                )
                              },
                              expression: "orderAmendPayModal.payCheck"
                            }
                          },
                          _vm._l(
                            _vm.orderAmendPayModal.paymentDetails,
                            function(item) {
                              return _c("Checkbox", {
                                key: item.value,
                                staticClass: "am-margin-top-xs",
                                attrs: { label: item.value },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var currentValue = ref.currentValue
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "am-inline-block am-text-not-line"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "am-padding-left-xs am-padding-right-sm am-inline-block w150"
                                              },
                                              [_vm._v(_vm._s(item.label))]
                                            ),
                                            _c("Input", {
                                              attrs: {
                                                disabled: !currentValue
                                              },
                                              model: {
                                                value: item.money,
                                                callback: function($$v) {
                                                  _vm.$set(item, "money", $$v)
                                                },
                                                expression: "item.money"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            }
                          ),
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "am-text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.calculatePayMoney.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("确认")]
              ),
              _c(
                "Button",
                {
                  staticClass: "am-btn-cancel",
                  nativeOn: {
                    click: function($event) {
                      _vm.orderAmendPayModal.visible = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "Modal",
        {
          attrs: { width: "850px" },
          on: { "on-visible-change": _vm.offlinePayModalChange },
          model: {
            value: _vm.offlinePayModal.visible,
            callback: function($$v) {
              _vm.$set(_vm.offlinePayModal, "visible", $$v)
            },
            expression: "offlinePayModal.visible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("补充更多支付方式")
          ]),
          _c("div", { staticClass: "offline-pay am-g-collapse am-cf" }, [
            _c("div", { staticClass: "offline-pay-hint" }, [
              _vm._v(
                "*请根据顾客需要选择对应的线下支付方式，提交订单后顾客后续若未进行扫码支付，订单将记录选择的支付方式"
              )
            ]),
            _c(
              "div",
              {
                staticClass:
                  "offline-pay-info am-padding-vertical-sm am-u-sm-12"
              },
              [
                _c("div", { staticClass: "am-u-sm-4" }, [
                  _c("span", [_vm._v("顾客需付：")]),
                  _c(
                    "span",
                    { staticClass: "prefix-price-unit am-color-price" },
                    [
                      _vm._v(
                        _vm._s(_vm.currency) +
                          _vm._s(_vm._f("formatPrice")(_vm.total, true))
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "am-u-sm-4" }, [
                  _c("span", [_vm._v("目前总额：")]),
                  _c(
                    "span",
                    { staticClass: "prefix-price-unit am-color-price" },
                    [
                      _vm._v(
                        _vm._s(_vm.currency) +
                          _vm._s(
                            _vm._f("formatPrice")(
                              _vm.offlinePayModal.total,
                              true
                            )
                          )
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "am-u-sm-4" }, [
                  _c("span", { staticClass: "am-color-price" }, [
                    _vm._v("还差：")
                  ]),
                  _c(
                    "span",
                    { staticClass: "prefix-price-unit am-color-price" },
                    [
                      _vm._v(
                        _vm._s(_vm.currency) +
                          _vm._s(
                            _vm._f("formatPrice")(
                              _vm.offlinePayModal.difference,
                              true
                            )
                          )
                      )
                    ]
                  )
                ])
              ]
            ),
            _c("div", { staticClass: "am-u-sm-12 offline-pay-content" }, [
              _c("div", { staticClass: "am-u-sm-12 offline-pay-header" }, [
                _c(
                  "div",
                  { staticClass: "am-u-sm-4" },
                  [
                    _c(
                      "checkbox",
                      {
                        staticClass: "am-padding-left-sm",
                        attrs: { isAllCheck: "" },
                        on: { change: _vm.offlinePayAllCheckChange },
                        model: {
                          value: _vm.offlinePayModal.isAllCheck,
                          callback: function($$v) {
                            _vm.$set(_vm.offlinePayModal, "isAllCheck", $$v)
                          },
                          expression: "offlinePayModal.isAllCheck"
                        }
                      },
                      [_vm._v("操作")]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "am-u-sm-8" }, [_vm._v("支付金额")])
              ]),
              _c(
                "div",
                { staticClass: "offline-pay-form am-padding-bottom-xs" },
                [
                  _c(
                    "checkbox-group",
                    {
                      staticClass:
                        "am-flex am-flex-column offline-pay-form-group",
                      on: { "on-change": _vm.offlinePayChange },
                      model: {
                        value: _vm.offlinePayModal.payCheck,
                        callback: function($$v) {
                          _vm.$set(_vm.offlinePayModal, "payCheck", $$v)
                        },
                        expression: "offlinePayModal.payCheck"
                      }
                    },
                    _vm._l(_vm.offlinePayModal.paymentDetails, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.value,
                          staticClass: "offline-pay-form-item am-margin-top-xs"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "am-inline-block am-padding-left-sm w-u-4"
                            },
                            [
                              _c(
                                "Checkbox",
                                {
                                  staticClass: "am-margin-top-xs",
                                  attrs: { label: item.value }
                                },
                                [_c("span", [_vm._v(_vm._s(item.label))])]
                              )
                            ],
                            1
                          ),
                          _c("Input", {
                            staticClass: "w-u-4",
                            attrs: {
                              disabled: item.disabled,
                              placeholder: item.placeholder,
                              type: "number"
                            },
                            on: {
                              "on-blur": function($event) {
                                return _vm.verifyOfflinePay(item)
                              }
                            },
                            model: {
                              value: item.money,
                              callback: function($$v) {
                                _vm.$set(item, "money", $$v)
                              },
                              expression: "item.money"
                            }
                          }),
                          item.error
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "am-inline-block am-padding-left-xs"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "am-color-warning" },
                                    [_vm._v(_vm._s(item.error))]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "am-text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.saveOfflinePayModal.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("确认")]
              ),
              _c(
                "Button",
                {
                  staticClass: "am-btn-cancel",
                  nativeOn: {
                    click: function($event) {
                      _vm.offlinePayModal.visible = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "Modal",
        {
          attrs: { width: "450px", closable: false, maskClosable: false },
          model: {
            value: _vm.changeResult.show,
            callback: function($$v) {
              _vm.$set(_vm.changeResult, "show", $$v)
            },
            expression: "changeResult.show"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("提示")
          ]),
          _c("div", { staticClass: "offline-pay am-g-collapse am-cf" }, [
            _c(
              "ul",
              [
                _vm._l(_vm.changeResult.tipsArr, function(item, idx) {
                  return _c("li", { key: idx }, [_vm._v(_vm._s(item))])
                }),
                _c("li", [
                  _vm._v(
                    "原订单号：" +
                      _vm._s(_vm.changeResult.originalOrderNo) +
                      " "
                  ),
                  _c(
                    "a",
                    {
                      staticStyle: { color: "#4F8DFF" },
                      on: {
                        click: function($event) {
                          return _vm.clickCopy(_vm.changeResult.originalOrderNo)
                        }
                      }
                    },
                    [_vm._v("点击复制")]
                  )
                ]),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.changeResult.originalExtOrderId,
                        expression: "changeResult.originalExtOrderId"
                      }
                    ]
                  },
                  [
                    _vm._v(
                      "原第三方订单号：" +
                        _vm._s(_vm.changeResult.originalExtOrderId) +
                        " "
                    ),
                    _c(
                      "a",
                      {
                        staticStyle: { color: "#4F8DFF" },
                        on: {
                          click: function($event) {
                            return _vm.clickCopy(
                              _vm.changeResult.originalExtOrderId
                            )
                          }
                        }
                      },
                      [_vm._v("点击复制")]
                    )
                  ]
                )
              ],
              2
            )
          ]),
          _c(
            "div",
            {
              staticClass: "am-text-center",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.confirmChangeOrderDone.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60747c98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60747c98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/order/MoreInfo/MoreInfoNew.vue
// module id = D453
// module chunks = 0